import {SearchQueryParams} from '../../models/search-query-params.model';

export namespace ReportsActions {
    export class GetReportsItems {
        static readonly type = 'ReportsActions.GetReportsItems';
    }

    export class GetReport {
        static readonly type = 'ReportsActions.GetReport';

        constructor(public activeReportCode: string) {
        }
    }

    export class GenerateFilteredReport {
        static readonly type = 'ReportsActions.GenerateFilteredReport';

        constructor(public params?: SearchQueryParams) {
        }
    }

    export class ClearReportData {
        static readonly type = 'ReportsActions.ClearReportData';
    }

    export class GenerateFilteredReportSuccess {
        static readonly type = 'ReportsActions.GenerateFilteredReportSuccess';
    }
}
